import React, { useEffect, useState } from 'react';
import fetchIntercept from 'fetch-intercept';
import { Guid as guid } from 'guid-typescript';
import PageLayout from './layout/pageLayout/PageLayout';
import AppStoreComponent from './components/appStoreComponent/AppStoreComponent';
import { useSelector,useDispatch } from 'react-redux';
import { IStore } from './store';
import { fetchDataSources, fetchUserApps } from './services/userProfile.service';
import Footer from './components/common/footer/Footer';
import DashboardContextProvider from './context/dashboardContext';
import { getCurrentSessionId } from './services/session.service';
import { X_TENANT_ID } from './app.constant';
import { internalSources, publicSources } from './label.constant';
import ErrorBoundary from './components/common/errorBoundary/ErrorBoundary';
import PolicyStepper from './components/common/policy/PolicyStepper';
import UnAuthorizedAccess from './components/unAuthorizedAccess/UnAuthorizedAccess';
import { useNavigate } from 'react-router-dom';
import { DigitalData } from './utils/adobeAnalytics/models/digitalDataModel';
import { digitaldata } from './utils/adobeAnalytics/config';
import { executeAnalytics, getLastUri } from './utils/adobeAnalytics/adobeAnalyticsHelperFn';
import { isTeamsApp } from './utils/commonUtils';
import { selectedSourceValues } from './store/actions/commonActions';


declare global { 
  interface Window { 
    digitaldata: DigitalData; 
  } 
} 

if (!window.digitaldata) { 
  window.digitaldata = digitaldata; 
} 
let userId: string;
function App(): JSX.Element {
  const dispatch = useDispatch();
  const showPrivacyAndTermsModal = useSelector(
    (store: IStore) => store.common.showPrivacyAndTermsModal
  );
  const checkedCheckboxes = useSelector((state: any) => state.common?.checkedCheckboxes);
  const IsDnfOpenAiSearchTriggered = useSelector((state: IStore) => state.common?.triggerDnfOpenAiSearchValue);
  if (IsDnfOpenAiSearchTriggered) {
    if (checkedCheckboxes && checkedCheckboxes.includes('Embryonic') && checkedCheckboxes.includes('Market reports') && !checkedCheckboxes.includes('Open AI')) {
      dispatch(selectedSourceValues({ checkedCheckboxes: ['Open AI', 'Embryonic', 'Market reports'] }));
    }
    else if (checkedCheckboxes && checkedCheckboxes.includes('Embryonic') && !checkedCheckboxes.includes('Open AI')) {
      dispatch(selectedSourceValues({ checkedCheckboxes: ['Open AI', 'Embryonic'] }));
    }
    else if (checkedCheckboxes && checkedCheckboxes.includes('Market reports') && !checkedCheckboxes.includes('Open AI')) {
      dispatch(selectedSourceValues({ checkedCheckboxes: ['Open AI', 'Market reports'] }));
    } 
  }

  const showUnauthorizedAccess = useSelector(
    (store: IStore) => store.common.showUnauthorizedAccess
  );
  const userName = useSelector((state: IStore) => state.userProfile?.userData?.displayName);
  const isFavouriteStatus = useSelector((state: IStore) => state.common?.isFavouriteStatus);
  const [customError, setCustomError] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const [userApps, setUserApps] = useState<any>({});
  const [isTeamsSourceApp, setIsTeamsSourceApp] = useState<boolean>(isTeamsApp());

  const groupDataSources = (dataSources: any) => {
    // Remove "Surveys" from dataSources
    const filteredDataSources = dataSources?.filter((dataSource: string) => dataSource !== 'Surveys');

    const internalDataSources = filteredDataSources?.filter((dataSource: string) =>
      internalSources.includes(dataSource)
    );
    const publicDataSources = filteredDataSources?.filter((dataSource: string) =>
      publicSources.includes(dataSource)
    );

    const orderedInternal =
      internalDataSources
        ?.slice()
        .sort(
          (a: string, b: string) =>
            internalSources.indexOf(a as string) - internalSources.indexOf(b as string)
        ) || [];

    const groupedDataSources: any = {
      public: publicDataSources,
      internal: orderedInternal
    };

    if (filteredDataSources?.includes('Ey expert')) {
      groupedDataSources.findEyExpert = filteredDataSources.findEyExpert;
    }

    if (filteredDataSources?.includes('Upload document and query')) {
      groupedDataSources.uploadDocument = filteredDataSources.uploadDocument;
    }

    return groupedDataSources;
  };

  const [allDataSources, setDataSources] = useState<any>({});
  const [errorCode, setErrorCode] = useState<any>(null);

  const getDataSources = async () => {
    setIsLoading(true);
    let result: any;
    result = await fetchDataSources();
    const groupedDataSources = groupDataSources(result?.dataSources);
    setUserApps(result.apps);
    setDataSources(groupedDataSources);
    setIsLoading(false);
  };

  useEffect(() => {
    getDataSources();
    let prevPageLastUri = getLastUri(window.location.href);
    executeAnalytics({ page: { pageName: prevPageLastUri } });
    const timer = setInterval(() => {
      const lastUri = getLastUri(window.location.href);
      if (lastUri != prevPageLastUri) {
        executeAnalytics({ page: { pageName: lastUri } });
        prevPageLastUri = lastUri;
      }
    }, 500);
    return () => clearInterval(timer);
  }, [isFavouriteStatus,isTeamsSourceApp]);

  const sessionId = getCurrentSessionId();

  fetchIntercept.register({
    request: function (url: any, config: { headers: any }) {
      if (!config.headers) {
        config.headers = {};
      }
      config!.headers['Request-Id'] = guid.create();
      config!.headers['X-Correlation-Id'] = guid.create();
      config!.headers['X-Window-Id'] = sessionId;
      config!.headers['X-Tenant-Id'] = X_TENANT_ID;
      config!.headers['session-id'] = sessionId;
      return [url, config];
    },

    requestError: function (error: any) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },

    response: function (response: any) {
      // Modify the reponse object
      return response;
    },

    responseError: function (error: any) {
      // Handle an fetch error
      return Promise.reject(error);
    }
  });

  const navigate = useNavigate();

  useEffect(() => {
    const navigationEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
      if (navigationEntry && navigationEntry.type === 'reload') {
      setTimeout(() => {
        navigate('/');
      }, 10);
    }
  }, []);

  return (
    <div className='App'>

      <>
        {!showPrivacyAndTermsModal && (
         showUnauthorizedAccess ? (
            <UnAuthorizedAccess />
          ) : (
            <ErrorBoundary>
              <DashboardContextProvider>
                <AppStoreComponent dataSources={allDataSources} userApps={userApps} isLoading={isLoading} />
              </DashboardContextProvider>
              <Footer />
            </ErrorBoundary>
          )
        )}
        {showPrivacyAndTermsModal && (
          <div className="page-layout se-container">
            <PolicyStepper />
          </div>
        )}
      </>
    </div>
  );

}

export default App;
